module.exports = __webpack_public_path__ + "img/solution-software-system-pic-2.4779a3d0.png";